import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { unsubscribeAPI } from '../utils/api';
import { format } from 'date-fns';
import { UserX } from 'lucide-react';

const UnsubscribeLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLogs();
  }, []);

  const loadLogs = async () => {
    try {
      const response = await unsubscribeAPI.getLogs();
      setLogs(response.data);
    } catch (error) {
      console.error('Failed to load logs:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="p-6 md:p-8 lg:p-12">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold tracking-tight text-[#F3F4F6] mb-2">
            Unsubscribe Logs
          </h1>
          <p className="text-lg text-[#9CA3AF]">
            View all unsubscribe requests from your email campaigns
          </p>
        </div>

        {/* Logs Table */}
        <div className="rounded-lg border border-[#2A2D36] bg-[#13151A]/80 backdrop-blur-sm overflow-hidden shadow-[0_4px_20px_-2px_rgba(0,0,0,0.5)]">
          {loading ? (
            <p className="text-[#9CA3AF] text-center py-12">Loading logs...</p>
          ) : logs.length === 0 ? (
            <div className="text-center py-12">
              <UserX size={48} className="mx-auto text-[#9CA3AF] mb-4" />
              <p className="text-[#9CA3AF]">No unsubscribe logs yet</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-[#1F2128] border-b border-[#2A2D36]">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-[#9CA3AF] uppercase tracking-wider">
                      Email
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-[#9CA3AF] uppercase tracking-wider">
                      Domain
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-[#9CA3AF] uppercase tracking-wider">
                      Language
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-[#9CA3AF] uppercase tracking-wider">
                      IP Address
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-[#9CA3AF] uppercase tracking-wider">
                      Date & Time
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#2A2D36]">
                  {logs.map((log) => (
                    <tr
                      key={log.id}
                      data-testid={`log-${log.id}`}
                      className="hover:bg-[#1F2128] transition-colors"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-[#F3F4F6]">
                        {log.email}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-[#9CA3AF]">
                        {log.domain}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-[#9CA3AF]">
                        <span className="px-2 py-1 rounded-md bg-[#183871]/10 text-[#183871] text-xs font-medium uppercase">
                          {log.language}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-[#9CA3AF] font-mono">
                        {log.ip || 'N/A'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-[#9CA3AF] font-mono">
                        <div>{format(new Date(log.timestamp), 'MMM dd, yyyy')}</div>
                        <div className="text-xs">{format(new Date(log.timestamp), 'HH:mm:ss')}</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default UnsubscribeLogs;
